import { handleKeyEnter } from '@soap/util-soap'
import { Cell, Text, Tooltip, VFlow } from 'bold-ui'
import { usePecField } from 'components/form/core/hooks/useField'
import { MedicamentoCatmatSelectField } from 'components/form/field/select/MedicamentoCatMatSelectField'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel } from '../../../model-prescricao'
import { RENOVACAO_TOOLTIP_TEXT } from '../../utils/constants-prescricao'

export interface MedicamentoSectionProps {
  path: MetaRoot<MedicamentoFormModel>
  onChange: () => void
  disabled: boolean
}

export default function MedicamentoSection({ onChange, path, disabled }: Readonly<MedicamentoSectionProps>) {
  const { input: principioAtivoInput } = usePecField({ name: path.principioAtivoCombo, subscription: { value: true } })
  const principioAtivoCombo = principioAtivoInput.value
  const tooltipText = disabled ? RENOVACAO_TOOLTIP_TEXT : undefined

  return (
    <>
      <Cell size={7} data-cy='PrincipioAtivo'>
        <Tooltip text={tooltipText}>
          <MedicamentoCatmatSelectField
            name={path.principioAtivoCombo}
            label='Princípio ativo / medicamento'
            onKeyUp={handleKeyEnter}
            required
            onChange={onChange}
            data-cy='PrincipioAtivoCombobox'
            disabled={disabled}
          />
        </Tooltip>
      </Cell>
      <Cell size={5} data-cy='Concentracao'>
        <VFlow vSpacing={0.2}>
          <Text fontWeight='bold'>Concentração</Text>
          <Text data-cy='ConcentracaoLabel'>{principioAtivoCombo?.medicamento?.concentracao ?? '-'} </Text>
        </VFlow>
      </Cell>
    </>
  )
}
